import apiClient from "../vue/http/axios";

const notProfile = 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png'

async function getLocations(data) {
  const resp = await apiClient.post(`locations/get_all_company_locations`, {data});
  const items = [{id: null, name: `General`}]
  items.push(...resp.data.data.map(item => ({id: item.id, name: item.name})));
  return items;
}

async function getUsers() {
  const users = await apiClient.get('approved_user/index_approvers_with_names');
  return [{ id: null, name: 'Todos' }, ...users.data.data];
}

async function getGeneralStats(params) {
  const response = await apiClient.get('invited_client/index_invited_stats', {params});
  return {
    approved: response.data.approved_invitations,
    created: response.data.created_invitations,
    denied: response.data.deny_invitations,
    cancelled: response.data.cancelled_invitations ? response.data.cancelled_invitations : 0 , 
    expired: response.data.expired_invitations ? response.data.expired_invitations : 0,
    pending: response.data.pending_invitations ? response.data.pending_invitations : 0
  };
}

async function getInvitationTypesStats(params) {
  
  const resp = await apiClient.get('invited_client/invitations_by_invited_type_status', {params});
  return resp.data.data ?? [];
}

async function getApproversStats(params) {
  const resp = await apiClient.get('approved_user/index_approver_stats',  {params});

  return (resp.data.data ?? []).map(item => ({
    photo: item.picture ?? notProfile,
    name: item.name,
    approved: item.approved_count,
    denied: item.denied_count,
    id: item.id,
    averageApproval: '02:22 min'
  }));
}

async function getDenialStats(params) {  
  const resp = await apiClient.get('approved_user/index_approver_stats', {params});
  return (resp.data.data ?? []).filter(item => item.denied_count > 0).map(item => ({
    photo: item.picture ?? notProfile,
    name: item.name,
    denied: item.denied_count,
    id: item.id,
  }));
}

async function getYearlyStats(params) {
  const resp = await apiClient.get('invited_client/index_annual_invitations', {params});
  return resp.data.data;
}

async function getDeniedSpecificStats(params) {
  const resp = await apiClient.get('approved_user/denial_reasons_summary', {params});
  return (resp.data.data ?? []).map(item => ({
    id: item.id,
    name: item.name,
    quantity: item.count,
  }));
}


/**
 * @typedef {Object} getTopInvitationsParams 
 * @property {string} type
 * @property {number} [location_id]
 * @property {string} [start_date]
 * @property {string} [end_date]
 */

/**
 * @async
 * @function getTopInvitations
 * @param {getTopInvitationsParams} params 
 * @returns {Promise<Object>}
 */
async function getTopInvitations(params) {

  try {

    const { data }= await apiClient.get('invited_client/index_top_invitations', {params});
  
    return data

  } catch (error) {
    throw new Error("Algo salió mal al obtener las invitaciones top")
  }


}


/**
 * @typedef {Object} InvitationParams
 * @property {number} user_id - ID of the inviting person.
 * @property {string} mobile - Mobile phone
 * @property {string} [month] - Optional month filter (format: MM-YYYY).
 */

/**
 * Returns the details from a top invitation, container the name, email, profile pic of the
 * inviting part and the list of invitations from the inviting part to a specific guest.
 *
 * @async
 * @function getTopInvitationDetail
 * @param {InvitationParams} params 
 * @returns {Promise<Object>} The Response contains the inviting part information, guest information and list of invitations for that guest
 * @throws {Error} If the request fails throws a generic error
 */
async function getTopInvitationDetail(params){
  try {
    const { data }= await apiClient.get('invited_client/index_top_invitations_detail', {params});
    return data
  } catch (error) {
    throw new Error("Algo salió mal obteniendo los detalles")
  }

}

async function getInvitationsDetailByType(params){

  const { data } = await apiClient.get("invited_client/index_invited_by_type", {params})
  
  return data


}


export default {
  getLocations,
  getUsers,
  getGeneralStats,
  getInvitationTypesStats,
  getApproversStats,
  getDenialStats,
  getYearlyStats,
  getDeniedSpecificStats,
  getTopInvitations,
  getInvitationsDetailByType,
  getTopInvitationDetail,
}